import React from "react";
import { ShieldCheck, XCircle, Landmark, Scale } from "lucide-react";

/**
 * Slim trust bar shown site-wide beneath the Header.
 * 4 promises. Dismissable via CSS class 'mv-low-data' (auto hidden in low-data mode
 * for bandwidth savings).
 */
export default function TrustBar() {
  const items = [
    { i: <ShieldCheck size={13}/>, t: "Title deed in your name" },
    { i: <XCircle    size={13}/>, t: "No immigration questions" },
    { i: <Landmark   size={13}/>, t: "Not a bank / remittance" },
    { i: <Scale      size={13}/>, t: "Independent legal oversight" },
  ];
  return (
    <div className="mv-green-bg text-white/90 text-[11.5px] tracking-[0.14em] mv-no-lowdata" data-testid="trust-bar">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-1.5 flex flex-wrap items-center gap-x-6 gap-y-1 justify-center md:justify-between">
        {items.map((it) => (
          <div key={it.t} className="flex items-center gap-1.5 whitespace-nowrap">
            <span style={{ color: "var(--mv-gold)" }}>{it.i}</span>
            <span className="uppercase">{it.t}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
